import { connect } from 'react-redux';
import React, { Component } from 'react';
import { func, arrayOf, bool } from 'prop-types';
import Radium from 'radium';
import { UTLoading } from '@widergy/energy-ui';

import { actionCreators as notificationActions, notificationPropTypes } from 'redux/notificationHandlers';
import UTNotificationList from 'app/components/UTNotificationList';
import withPagination from 'app/components/UTPagination/HOCs/pagination';

import styles from './styles';

class NotificationList extends Component {
  onClickNotification = id => {
    this.props.onClickNotification(id);
    this.props.setNotificationAsRead(id);
  };

  render() {
    return (
      <div style={this.props.rows.length > 0 ? styles.containerShow : styles.containerHidden}>
        <UTNotificationList
          width={styles.containerShow.width}
          height={styles.containerShow.height}
          rows={this.props.rows}
          onClick={this.onClickNotification}
          onMount={this.props.onMount}
          append={this.props.append}
          onRowsRendered={this.props.onRowsRendered}
        />
        {this.props.loading && (
          <div style={styles.spinnerContainer}>
            <UTLoading loading={this.props.loading} size={45} text=" " />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: pageSize => dispatch(notificationActions.getUserNotifications(pageSize)),
  append: (pageNumber, pageSize) => dispatch(notificationActions.appendNotifications(pageNumber, pageSize)),
  setNotificationAsRead: id => dispatch(notificationActions.setNotificationAsRead(id))
});

const mapStateToProps = store => ({
  rows: store.notification.notificationList,
  loading: store.notification.notificationListLoading
});

NotificationList.propTypes = {
  rows: arrayOf(notificationPropTypes).isRequired,
  onMount: func,
  append: func,
  setNotificationAsRead: func,
  onClickNotification: func,
  onRowsRendered: func,
  loading: bool
};

export default connect(mapStateToProps, mapDispatchToProps)(withPagination(Radium(NotificationList), 8));
